import { createContext } from 'react';

export interface ApiCacheContextType<RecordType> {
    get: (key: string) => Promise<RecordType> | undefined;
    reset: (key: string) => void;
    set: (key: string, value: Promise<RecordType>) => void;
}

export default createContext<ApiCacheContextType<any>>(undefined as any);
